import ApiRequestManagerInstance from '../ApiRequestManager';
import Channel from '../../classes/channel';
import { IChannelAddonRequest } from '../../types/interfaces/channel';
import { store } from '../../store/store';

const MAX_CHANNELS = 16;

async function channelsAddonsRequest(addon: string, slice = true, planId = '') {
  const promise = new Promise<Channel[] | null>(async (resolve) => {
    const { user } = store.getState();
    try {
      const response: { data: IChannelAddonRequest[] } =
        (await ApiRequestManagerInstance.get({
          endpoint: {
            url: user?.isAnonymous ? 'cdnSyncUrl' : 'apiUrl',
            section: 'addons',
            type: user?.isAnonymous ? 'channelsFree' : 'channels',
            replacement: user?.isAnonymous ? planId : addon,
          },
        })) as unknown as { data: IChannelAddonRequest[] };

      const channels: Channel[] = response.data.map((remoteCh) => {
        return new Channel({ ...remoteCh, master: remoteCh });
      });
      let finalChannels = slice ? channels.slice(0, MAX_CHANNELS) : channels;
      const { channels: storeChannels } = store.getState();
      finalChannels = finalChannels.sort((ch1, ch2) => {
        const index1 = storeChannels.channelsData?.findIndex(
          (ch) => ch1.id === ch.id
        );
        const index2 = storeChannels.channelsData?.findIndex(
          (ch) => ch2.id === ch.id
        );
        return (index1 || 0) < (index2 || 0) ? 1 : -1;
      });
      resolve(
        finalChannels.filter((ch) => {
          return storeChannels.channelsData?.find((stCh) => {
            return stCh.id === ch.id;
          });
        })
      );
    } catch (e) {
      resolve(null);
    }
  });
  return promise;
}

export default channelsAddonsRequest;
